import { Image } from "@components/common";
import { ReactNode } from "react";
import Link from "next/link";

interface AccountSectionProps {
  title: string;
  subTitle: string | ReactNode;
  children: React.ReactNode;
}

export default function AccountSection({
  title,
  subTitle,
  children,
}: AccountSectionProps) {
  return (
    <div className="h-full mx-auto w-full flex items-center px-10">
      {/* logo */}
      <div className="w-96 flex flex-col items-center flex-shrink-0">
        <Link href="/" id="back-to-main">
          <Image className="h-[100px]" src={"/logo2.svg"} alt="" />
        </Link>
        {/* Title */}
        <div className="flex-shrink-0">
          <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900">
            {title}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">{subTitle}</p>
        </div>
      </div>

      {/* Form */}
      <div className="w-full">
        <div className="py-8 px-4 sm:rounded-lg sm:px-10">{children}</div>
      </div>
    </div>
  );
}
